import React from 'react';
import PropTypes from 'prop-types';
import ScholarshipTest from '../../../components/scholarship';
import HeaderFooterLayout from '../../../components/home/layouts/HeaderFooterLayout';
import GET_ENTITY_BY_SLUG from '../../../gql/queries/get-entity-by-slug.gql';
import GET_SCHOLARSHIP_BY_SLUG from '../../../gql/queries/scholarship.gql';
import { initializeApollo } from '../../../../apollo-ssr';
import { getServerSideToken } from '../../../utils/auth-utils';
import { isWebView } from '../../../utils/helpers';
import fetchHeaderFooterData from '../../../utils/header-footer-fetcher';

export default function ScholarshipPage({
  headerData,
  footerData,
  headerHTMLContent,
  footerHTMLContent,
  renderMode,
  initialScholarshipData,
  initialEntityData,
}) {
  const isWebViewAvailable = isWebView();
  if (isWebViewAvailable) {
    return <ScholarshipTest initialScholarshipData={initialScholarshipData} initialEntityData={initialEntityData} />;
  }
  return (
    <HeaderFooterLayout
      paddingClass="p-2"
      headerData={headerData}
      footerData={footerData}
      headerHTMLContent={headerHTMLContent}
      footerHTMLContent={footerHTMLContent}
      renderMode={renderMode}
    >
      <ScholarshipTest initialScholarshipData={initialScholarshipData} initialEntityData={initialEntityData} />
    </HeaderFooterLayout>
  );
}

ScholarshipPage.propTypes = {
  headerData: PropTypes.object,
  footerData: PropTypes.object,
  headerHTMLContent: PropTypes.string,
  footerHTMLContent: PropTypes.string,
  renderMode: PropTypes.object,
  initialScholarshipData: PropTypes.object,
  initialEntityData: PropTypes.object,
};

export async function getServerSideProps(context) {
  let hostname;
  if (context && context.req && context.req.headers && context.req.headers.host) {
    hostname = context.req.headers.host;
  } else {
    hostname = 'nextias.com';
  }

  const userToken = getServerSideToken(context.req);
  const apolloClient = initializeApollo(null, userToken, hostname);

  try {
    let slugParam;
    if (context && context.params && context.params.slug) {
      slugParam = context.params.slug;
    }

    // Fetch entity and scholarship data for SSR
    const entityResult = await apolloClient.query({
      query: GET_ENTITY_BY_SLUG,
      variables: { slug: slugParam, lang: 'en' },
      skip: !slugParam,
      errorPolicy: 'ignore',
    });

    const scholarshipResult = await apolloClient.query({
      query: GET_SCHOLARSHIP_BY_SLUG,
      variables: { slug: slugParam },
      skip: !slugParam,
      errorPolicy: 'ignore',
    });

    const {
      headerData,
      footerData,
      headerHTMLContent,
      footerHTMLContent,
      renderMode,
    } = await fetchHeaderFooterData(apolloClient, 'en');

    return {
      props: {
        headerData,
        footerData,
        headerHTMLContent,
        footerHTMLContent,
        renderMode,
        initialScholarshipData: scholarshipResult?.data || null,
        initialEntityData: entityResult?.data || null,
        apolloState: apolloClient.cache.extract(),
      },
    };
  } catch (error) {
    console.error('Error fetching header/footer data for scholarship page:', error);
    return {
      props: {
        headerData: null,
        footerData: null,
        headerHTMLContent: null,
        footerHTMLContent: null,
        renderMode: { header: 'json', footer: 'json' },
      },
    };
  }
}
